import { Link } from 'react-router-dom';

const bannerImage =
  'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20of%20soft%20navy%20blue%20gradient%20with%20warm%20orange%20light%20streaks%20and%20bokeh%20particles%2C%20artistic%20atmospheric%20texture%2C%20high%20detail&width=1600&height=600&seq=recommend-banner-01&orientation=landscape';

export default function RecommendNav() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-lg bg-primary-900">
          <div className="absolute inset-0 opacity-30">
            <img
              src={bannerImage}
              alt="相关推荐专题背景"
              title="善良的小姨子 - 相关推荐专题"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10 px-6 md:px-12 py-10 md:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-primary-950 text-xs font-medium mb-4">
                <i className="ri-bookmark-3-line w-4 h-4 flex items-center justify-center"></i>
                专题策划
              </span>
              <h2 className="font-heading font-bold text-background-50 text-2xl md:text-3xl mb-3">
                看完不过瘾？这些剧同样好哭
              </h2>
              <p className="text-background-200 text-sm md:text-base leading-relaxed">
                我们整理了与《善良的小姨子》风格相近的家庭温情剧集，从邻里群像到意难平的亲情和解，帮你把这份温暖延续下去。
              </p>
            </div>
            <Link
              to="/special/recommend"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm md:text-base font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer shrink-0"
            >
              进入推荐专题
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}